// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2cz-1","container_closeIcon":"styles_container_closeIcon__1-y_s","container_accept":"styles_container_accept__2YfP9"};